import React, { useEffect, useState } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import { Table, Button, Row, Col, Input, DatePicker, message, Upload, InputNumber, Flex, Spin, Checkbox } from 'antd';
import APIService from '../../Service/APIService';
import FormConfig from '../../Config/FormConfig';
import { InboxOutlined, ExclamationCircleFilled, CheckCircleFilled, FileDoneOutlined, FilterOutlined, SortAscendingOutlined, SortDescendingOutlined, CloseCircleOutlined, LoadingOutlined, DeleteOutlined } from '@ant-design/icons';
import { Formik } from 'formik';
// import moment from 'moment';
import dayjs from 'dayjs';
import Swal from 'sweetalert2';
import './CommissionsCss.css';
import Select from 'react-select';
import CustomHeader from '../CustomHeader/CustomHeader';
import { set } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthProvider.js';
import { hasPermission } from '../../Config/permissions.js';

const NewCommissionContractTemp = () => {
  const { user, isReady } = useAuth();
  const userData = user;
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const [fieldsArr, setFieldsArr] = useState([]);
  const [initialValues, setInitialValues] = useState(null);
  const [isEditable, setIsEditable] = useState(false);
  const [distributorOptions, setDistributorOptions] = React.useState([]);
  const [uploadContract, setUploadContract] = useState(null);
  const [uploadContractFileList, setUploadContractFileList] = useState([]);
  const [uploadContractFilename, setUploadContractFilename] = useState(null);
  const [productGroups, setProductGroups] = useState([]);
  const [existingCommissionContract, setExistingCommissionContract] = useState(null);
  const [allCommissionContracts, setAllCommissionContracts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploadContractFileBlobName, setUploadContractFileBlobName] = useState(null);

  const components = {
    header: {
      cell: ({ style, ...restProps }) => (
        <th
          {...restProps}
          style={{
            ...style,
            backgroundColor: '#ffffff',
            color: '#000',
            borderColor: '#ffffff',
            paddingBottom: '2px',
            fontWeight: 500,
            marginTop: '8px',
          }}
        />
      ),
    },
    body: {
      cell: ({ style, ...restProps }) => (
        <td
          {...restProps}
          style={{
            ...style,
            backgroundColor: '#ffffff',
            color: '#000',
            borderColor: '#ffffff',
            paddingTop: '0px',
          }}
        />
      ),
    },
  };

  const generateInitialValues = (fieldVal, data = null) => {
    let obj = {};
    if (!data) {
      for (const cur of fieldVal) {
        obj[cur.backendName] = null;
      }
    }
    else {
      for (const cur of fieldVal) {
        obj[cur.backendName] = (cur.backendName in data) ? data[cur.backendName] : null;
      }
    }
    return obj;
  }

  const generateFieldsArray = (data = null) => {
    const fields = FormConfig.NewCommissionContract;
    // console.log(accountFields);
    setFieldsArr(fields);
    const val = generateInitialValues(fields, data);
    console.log("Createedby ", val["CreatedBy"]);
    val["CreatedBy"] = (id !== null && id !== undefined) ? val["CreatedBy"] : userData.FirstName + " " + userData.LastName;
    val["CreatedByEmail"] = userData?.Email;

    if (location.state && location.state.type === "Duplicate") {
      // add one day to end date and save in start date
      val["StartDate"] = dayjs(val["EndDate"]).add(1, 'days').startOf('day');
      val["EndDate"] = null;
      val["IsEnded"] = false;
    }
    else{
      val["StartDate"] = val["StartDate"] === null ? null : dayjs(val["StartDate"]);
      val["EndDate"] = val["EndDate"] === null ? null : dayjs(val["EndDate"]);
      val["IsEnded"] = val["IsEnded"] === null ? false : val["IsEnded"];
    }
    console.log('Initial Values:', val);
    console.log("Createedby ", val["CreatedBy"]);
    setInitialValues(val);
    return val;
  };

  const columns = [
    {
      title: 'Manufacturer',
      dataIndex: 'ManufacturerName',
      width: '20%',
      render: (_, record) => (
        <Input
          defaultValue={record.ManufacturerName}
          disabled={true}
        />
      ),
    },
    {
      title: 'Product',
      dataIndex: 'ProductGroupName',
      width: '20%',
      render: (_, record) => (
        <Input
          value={record.ProductGroupName}
          disabled={true}
        />
      ),
    },
    {
      title: 'Commission %',
      dataIndex: 'CommissionPercentage',
      width: '15%',
      render: (_, record) => (
        <InputNumber
          min={0}
          max={100}
          style={{ width: '100%' }}
          defaultValue={record.CommissionPercentage}
          onBlur={e =>
            handleInputChange(e, record.key, 'CommissionPercentage')
          }
          onPressEnter={e =>
            handleInputChange(e, record.key, 'CommissionPercentage')
          }
          disabled={!isEditable}
        />
      ),
    },
    {
      title: 'Is Tiered',
      dataIndex: 'IsTiered',
      width: '15%',
      render: (_, record) => (
        <Checkbox 
          defaultChecked={record.IsTiered}
          disabled={!isEditable}
          onChange={e => {
            const newData = productGroups.map(row => row.key === record.key ? { ...row, IsTiered: e.target.checked } : row);
            setProductGroups(newData);
          }}
        />
      ),
    },
    {
      title: 'Tier Two Start',
      dataIndex: 'TierTwoStart',
      width: '20%',
      render: (_, record) => (
        <Input
          defaultValue={record.TierTwoStart}
          style={{ width: '100%' }}
          onBlur={e =>
            handleInputChange(e, record.key, 'TierTwoStart')
          }
          onPressEnter={e =>
            handleInputChange(e, record.key, 'TierTwoStart')
          }
          disabled={isEditable === true ? (!record.IsTiered) : true}
        />
      ),
    },
    {
      title: 'Tier Two Commission Percentage',
      dataIndex: 'TierTwoCommissionPercentage',
      width: '20%',
      render: (_, record) => (
        <Input
          defaultValue={record.TierTwoCommissionPercentage}
          style={{ width: '100%' }}
          onBlur={e =>
            handleInputChange(e, record.key, 'TierTwoCommissionPercentage')
          }
          onPressEnter={e =>
            handleInputChange(e, record.key, 'TierTwoCommissionPercentage')
          }
          disabled={isEditable === true ? (!record.IsTiered) : true}
        />
      ),
    },
     {
      title: 'Tier Three Start',
      dataIndex: 'TierThreeStart',
      width: '20%',
      render: (_, record) => (
        <Input
          defaultValue={record.TierThreeStart}
          style={{ width: '100%' }}
          onBlur={e =>
            handleInputChange(e, record.key, 'TierThreeStart')
          }
          onPressEnter={e =>
            handleInputChange(e, record.key, 'TierThreeStart')
          }
          disabled={isEditable === true ? (!record.IsTiered) : true}
        />
      ),
    },
    {
      title: 'Tier Three Commission Percentage',
      dataIndex: 'TierThreeCommissionPercentage',
      width: '20%',
      render: (_, record) => (
        <Input
          defaultValue={record.TierThreeCommissionPercentage}
          style={{ width: '100%' }}
          onBlur={e =>
            handleInputChange(e, record.key, 'TierThreeCommissionPercentage')
          }
          onPressEnter={e =>
            handleInputChange(e, record.key, 'TierThreeCommissionPercentage')
          }
          disabled={isEditable === true ? (!record.IsTiered) : true}
        />
      ),
    },
  ];
  
  const handleInputChange = (e, key, column) => {
    if (column === "CommissionPercentage") {
      // allow only numbers between 0 and 100
      if (e.target.value < 0 || e.target.value > 100) {
        message.error("Commission Percentage should be between 0 and 100");
        return;
      }
      // allow only numbers
      if (isNaN(e.target.value)) {
        message.error("Commission Percentage should be a number");
        return;
      }
      // allow only 2 decimal places
      if (e.target.value.toString().split(".").length > 2) {
        message.error("Commission Percentage should be a number");
        return;
      }
      if (e.target.value.toString().split(".")[1]?.length > 2) {
        message.error("Commission Percentage should be a number");
        return;
      }
    }
    const newData = productGroups.map(row => row.key === key ? { ...row, [column]: e.target.value } : row);
    setProductGroups(newData);
  };

  const getContractData = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(`getcommissioncontractbyid?ID=${id}`);
    console.log("Commission Contract: ", response);
    setExistingCommissionContract(response?.data?.data?.CommissionContract);
    const newData = response?.data?.data?.CommissionContractProducts.map((item, index) => ({
      ...item,
      key: index + 1,
      CommissionPercentage: (item.CommissionPercentage === null || item.CommissionPercentage === undefined) ? 0 : item.CommissionPercentage
    }));
    setProductGroups(newData);

    if (response?.data?.data?.CommissionContract?.UploadContractFilename) {

      // const arrayBuffer = response?.data?.data?.CommissionContract?.UploadContract.data;
      // const bytes = new Uint8Array(arrayBuffer);
      // const blob = new Blob([bytes], { type: "application/pdf" });
      const filename = response?.data?.data?.CommissionContract?.UploadContractFilename ? response?.data?.data?.CommissionContract?.UploadContractFilename : "uploadcontract.pdf";
      setUploadContractFileList([{ name: filename, status: 'done', uid: '1' }]);
      setUploadContractFilename(filename);
      setUploadContractFileBlobName(response?.data?.data?.CommissionContract?.AzureBlobName);
    }

    generateFieldsArray(response?.data?.data?.CommissionContract);
    setIsEditable(false);
    return response?.data?.data?.CommissionContract;
  }

  const getDuplicateContractData = async () => {
    const ID = location.state?.data?.ID;
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(`getduplicatecommissioncontractbyid?ID=${ID}`);
    console.log("Duplicate Commission Contract: ", response);
    setExistingCommissionContract(response?.data?.data?.CommissionContract);
    const newData = response?.data?.data?.CommissionContractProducts.map((item, index) => ({
      ...item,
      key: index + 1,
      CommissionPercentage: (item.CommissionPercentage === null || item.CommissionPercentage === undefined) ? 0 : item.CommissionPercentage 
    }));
    setProductGroups(newData);

    if (response?.data?.data?.CommissionContract?.UploadContract) {
      // const arrayBuffer = response?.data?.data?.CommissionContract?.UploadContract.data;
      // const bytes = new Uint8Array(arrayBuffer);
      // const blob = new Blob([bytes], { type: "application/pdf" });
      const filename = response?.data?.data?.CommissionContract?.UploadContractFilename ? response?.data?.data?.CommissionContract?.UploadContractFilename : "uploadcontract.pdf";
      setUploadContractFileList([{ name: filename, status: 'done', uid: '1' }]);
      setUploadContractFilename(filename);
      setUploadContractFileBlobName(response?.data?.data?.CommissionContract?.AzureBlobName);
    }

    generateFieldsArray(response?.data?.data?.CommissionContract);
    setIsEditable(true);
    return response?.data?.data?.CommissionContract;
  }

  const getProductGroups = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend('getallproductgroupstemp');
    const newData = response?.data?.data.map((item, index) => ({
      ...item,
      key: index + 1,
      CommissionPercentage: (item.CommissionPercentage === null || item.CommissionPercentage === undefined) ? 0 : item.CommissionPercentage,
    }));
    console.log("Product Groups: ", newData);
    setProductGroups(newData);
  }

  const getDistributorOptions = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend('getalldistributors');
    // console.log("Distributors: ", response);
    let tempOptions = [];
    response?.data?.data.map((ele) => {
      tempOptions.push({
        value: ele.ID,
        label: ele.DistributorName
      });
    });
    setDistributorOptions(tempOptions);
    return tempOptions;
  }

  const getCommissionOptions = async (distID) => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(`commissionoptionstemp?DistID=${distID}`);
    console.log("Commission Options: ", response);
    let distData = response?.data?.data?.Distributors;
    let prodGroups = response?.data?.data?.ProductGroups;
    setAllCommissionContracts(response?.data?.data?.ExistingCommissionContracts);
    let tempOptions = [];
    distData.map((ele) => {
      tempOptions.push({
        value: ele.ID,
        label: ele.DistributorName
      });
    }
    );
    setDistributorOptions(tempOptions);
    const newData = prodGroups.map((item, index) => ({
      ...item,
      key: index + 1,
      CommissionPercentage: (item.CommissionPercentage === null || item.CommissionPercentage === undefined) ? 0 : item.CommissionPercentage,
    }));
    console.log("Product Groups: ", newData);
    setProductGroups(newData);
  }

  useEffect(() => {
    console.log("Create Commission Contracts");
    console.log("location:", location.state);
    // if (userData && userData.Type === "Account") {
    //   navigate(`/Account/${userData.AccountID}`);
    //   window.location.reload();
    // } else if (userData && userData.Type === "Distributor") {
    //   navigate(`/Distributor/${userData.DistributorID}`);
    //   window.location.reload();
    // }
    // else if(userData && userData?.Type === "Manufacturer") {
    //   navigate("/");
    //   window.location.reload();
    // }
    if (
      userData &&
      !hasPermission(
        userData,
        id ? "dist_contract.view" : "dist_contract.edit"
      )
    ) {
      navigate("/");
    }
    let val = null;
    if (id) {
      getDistributorOptions();
      getContractData().then((data) => {
        if (userData.Type === "Distributor") {
          if (data.DistributorID != userData.DistributorID) {
            window.location.href = `/Distributor/${userData.DistributorID}`;
          }
        }
        setLoading(false);
      });
    }
    else if (location.state && location.state.type === "Duplicate") {
      getDuplicateContractData().then((data) => {
        setLoading(false);
      })
    }
    else {
      if (userData.Type !== "Admin") {
        window.location.href = "/";
      }
      val = generateFieldsArray(null);
      setIsEditable(true);
      getDistributorOptions();
      getProductGroups().then(() => {
        setLoading(false);
      });
    }
  }, []);

  const downloadFile = async () => {
    const apiServe = new APIService();
    const sasUrl = await apiServe.getSasToken(uploadContractFileBlobName);

    const exists = await apiServe.checkBlobExists(sasUrl);
    if (!exists) {
      message.error("File does not exist.");
      return;
    }

    // download the file from Azure Blob Storage
    const link = document.createElement('a');
    link.href = sasUrl;
    link.download = '';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // const link = document.createElement("a");
    // let url = null;
    // console.log("Uploaded Contract: ", uploadContract);
    // url = window.URL.createObjectURL(uploadContract);
    // link.href = url;
    // link.setAttribute("download", uploadContractFilename); // Set the file name
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  }

  const uploadProps = {
    name: 'file',
    multiple: false,
    accept: ['.pdf'],
    // customRequest:  handleFile,
    disabled: !isEditable,
    onChange(info) {
      const { status } = info.file;
      // set limit of 4mb on file size and throw error
      // if (info.file.size > 4194304) {
      //   message.error(`${info.file.name} is too large, please select a file less than 4MB`);
      //   return;
      // }
      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (status === 'done') {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    },
  };

  const handleFile = async ({ file, onSuccess }) => {
    // setIvrReport(file);
    if (file.size > 4194304) {
      message.error(`${file.name} is too large, please select a file less than 4MB`);
      return;
    }
    setUploadContract(file);
    setUploadContractFilename(file.name);
    setUploadContractFileList([{ name: file.name, status: 'done', uid: '1' }]);
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  }

  const submitHandler = async (values) => {
    console.log("Values: ", values);
    values.UploadContractFilename = uploadContractFilename;
    console.log("productGroups: ", productGroups);
    // return;
    setLoading(true);
    // start date should be less than end date
    if (values.StartDate && values.EndDate) {
      if (values.StartDate.isAfter(values.EndDate)) {
        setLoading(false);
        message.error("Start date should be less than end date");
        return;
      }
    }

    if(values.IsEnded && values.EndDate === null) {
      setLoading(false);
      message.error("Please select end date");
      return;
    }

    // check if dates are overlapping with allcontracts start and end dates
    if (id === null || id === undefined) {
      const startDate = values.StartDate;
      const endDate = values.EndDate;
      console.log("allCommissionContracts: ", allCommissionContracts);
      if(startDate && endDate && allCommissionContracts.length > 0) {
        const check = allCommissionContracts.some((item) => {
          const contractStartDate = dayjs(item.StartDate);
          const contractEndDate = dayjs(item.EndDate);
          if (startDate.isAfter(contractStartDate) && startDate.isBefore(contractEndDate)) {
            message.error("Contract dates are overlapping with existing contracts");
            return true;
          }
          else if (endDate.isAfter(contractStartDate) && endDate.isBefore(contractEndDate)) {
            message.error("Contract dates are overlapping with existing contracts");
            return true;
          }
          return false;
        });
        if (check) {
          setLoading(false);
          return;
        }
      }
    }

    // check if all the product groups have commission percentage as number
    const check = productGroups.every((item) => {
      if (item.CommissionPercentage === null || item.CommissionPercentage === undefined) {
        message.error("Please enter commission percentage for all product groups");
        return false;
      }
      if (isNaN(item.CommissionPercentage)) {
        message.error("Commission percentage should be a number");
        return false;
      }
      if (item.CommissionPercentage < 0 || item.CommissionPercentage > 100) {
        message.error("Commission percentage should be between 0 and 100");
        return false;
      }
      return true;
    }
    );
    if (!check) {
      setLoading(false);
      return;
    }

    // check if isTiered is true then check if tier two start and commission percentage are not null
    const checkTiered = productGroups.every((item) => {
      if (item.IsTiered) {
        if (item.TierTwoStart === null || item.TierTwoStart === undefined) {
          message.error("Please enter tier two start for all product groups");
          return false;
        }
        if (item.TierTwoCommissionPercentage === null || item.TierTwoCommissionPercentage === undefined) {
          message.error("Please enter tier two commission percentage for all product groups");
          return false;
        }
        if (isNaN(item.TierTwoStart)) {
          message.error("Tier two start should be a number");
          return false;
        }
        if (item.TierTwoStart < 0) {
          message.error("Tier two start should be greater than 0");
          return false;
        }
        if (isNaN(item.TierTwoCommissionPercentage)) {
          message.error("Tier two commission percentage should be a number");
          return false;
        }
        if (item.TierTwoCommissionPercentage < 0 || item.TierTwoCommissionPercentage > 100) {
          message.error("Tier two commission percentage should be between 0 and 100");
          return false;
        }
      }
      return true;
    });

    if (!checkTiered) {
      setLoading(false);
      return;
    }

    // return;
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then(async (result) => {
      if (result.isConfirmed) {

        const postObj = {
          CommissionContract: values,
          ProductGroups: productGroups,
        };
        const apiServe = new APIService();
        let formData = new FormData();
        formData.append("data", JSON.stringify(postObj));
        formData.append("files", uploadContract);
        console.log("FormData: ", formData);
        let url = null;
        if (id !== null && id !== undefined) {
          url = `updatecommissioncontract?ID=${id}`;
        }
        else {
          url = `createcommissioncontract`;
        }
        console.log("URL: ", url);
        const response = await apiServe.addFileDataToBackend(formData, url, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
        });
        console.log("Response: ", response);
        if (response?.status === 200) {
          Swal.fire({
            title: 'Success!',
            text: response?.data?.message,
            icon: 'success',
            confirmButtonText: 'OK'
          }).then(() => {
            window.location.href = '/Distributor/' + values.DistributorID;
          });
        }
        else {
          Swal.fire({
            title: 'Error!',
            text: response?.data?.message,
            icon: 'error',
            confirmButtonText: 'OK'
          });
        }
      }
      else{
        setLoading(false);
      }
    });
  }

  const handleButtonClick = (submitForm) => {
    if (isEditable) {
      submitForm(); // Trigger form submission
    } else {
      setIsEditable(true); // Enable edit mode
    }
  };

  return (
    <div>
      {initialValues &&
        <CustomHeader leftTopText="Welcome back!"
          leftBottomText={id !== null && id !== undefined ? "Commission Contract (All Products Included)" : "New Commission Contract (All Products Included)"}
          rightTopText="Logged in as Admin"
          rightBottomText="User"
        />
      }
      {loading &&
        <Flex align="center" gap="middle">
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 48,
                }}
                spin
              />
            }
            fullscreen
          />
        </Flex>
      }
      {initialValues && (
        <Formik onSubmit={submitHandler} initialValues={initialValues} >
          {(formik) => (
            // console.log("formik: ", formik),
            <form onSubmit={formik.handleSubmit}>
              {id !== null && id !== undefined &&
                <div>
                  {hasPermission(userData, "dist_contract.edit") &&
                    <div style={{ display: 'flex', gap: '16px', margin: '30px 0px 30px 0px' }}>
                      <Button
                        type="primary"
                        style={{ marginBottom: 16, background: isEditable ? '#27a907' : '#ff9202' }}
                        onClick={() => handleButtonClick(formik.handleSubmit)}
                      >
                        {isEditable ? 'Save Changes' : 'Edit'}
                      </Button>
                    </div>
                  }
                </div>
              }
              <div style={{ background: '#e3e3e3', borderRadius: '5px', padding: '0px 8px', marginBottom: '30px' }}>
                <p style={{ fontWeight: '600', fontSize: '18px', lineHeight: '36px' }}>Contract Details</p>
              </div>
              <Row gutter={16}>
                <Col span={6} style={{ width: '100%' }}>
                  <label className="form-label">Distributor Name <span style={{ color: 'red' }}>*</span></label>
                  <Select
                    onBlur={() => formik.setFieldTouched("DistributorID")}
                    // title={formik.values["AccountID"]}
                    value={{ label: formik.values["DistributorName"], value: formik.values["DistributorID"] }}
                    // onChange={async (value, option) => {
                    onChange={async (selectedOption) => {
                      console.log("Value: ", selectedOption.value);
                      console.log("Option: ", selectedOption);
                      formik.setFieldValue("DistributorName", selectedOption.label);
                      formik.setFieldValue("DistributorID", selectedOption.value);
                      getCommissionOptions(selectedOption.value);
                    }}
                    style={{ width: '100%' }}
                    defaultValue=""
                    options={distributorOptions}
                    isDisabled={!isEditable}
                  />
                </Col>
                <Col span={6} style={{ width: '100%' }}>
                  <label className="form-label">Start Date<span style={{ color: 'red' }}>*</span></label>
                  <DatePicker
                    format="MM-DD-YYYY"
                    onBlur={() => formik.setFieldTouched("StartDate")}
                    title={formik.values["StartDate"]}
                    value={formik.values["StartDate"]}
                    onChange={(date, dateString) =>
                      formik.setFieldValue(
                        "StartDate",
                        date
                      )
                    }
                    style={{ width: '100%' }}
                    // disabledDate={(currentDate) => 
                    //   currentDate && (currentDate < dayjs().add(1, 'days').startOf('day') || currentDate.day() === 0)
                    // }
                    disabledDate={(currentDate) => {
                      const lastEndDate = allCommissionContracts.reduce((latest, contract) => {
                        const contractEndDate = dayjs(contract.EndDate);
                        return contractEndDate.isAfter(latest) ? contractEndDate : latest;
                      }, dayjs(0)); // Initialize with the earliest possible date
                      return currentDate && (currentDate < lastEndDate.add(1, 'days').startOf('day'));
                    }}
                    disabled={formik.values.DistributorID !== null ? !isEditable : true}
                  />
                </Col>
                <Col span={2} style={{ width: '100%' }}>
                  <label className="form-label">Has End Date <span style={{ color: 'red' }}>*</span></label>
                  <Checkbox
                    name="IsEnded"
                    checked={formik.values.IsEnded}
                    onChange={(e) => {
                      formik.setFieldValue("IsEnded", e.target.checked);
                      if (e.target.checked) {
                        formik.setFieldValue("EndDate", dayjs());
                      }
                    }}
                    disabled={formik.values.DistributorID !== null ? !isEditable : true}
                  />
                </Col>
                {formik.values.IsEnded &&
                  <Col span={6} style={{ width: '100%' }}>
                    <label className="form-label">End Date<span style={{ color: 'red' }}>*</span></label>
                    <DatePicker
                      format="MM-DD-YYYY"
                      onBlur={() => formik.setFieldTouched("EndDate")}
                      title={formik.values["EndDate"]}
                      value={formik.values["EndDate"]}
                      onChange={(date, dateString) =>
                        formik.setFieldValue(
                          "EndDate",
                          date
                        )
                      }
                      style={{ width: '100%' }}
                      // disabledDate={(currentDate) => 
                      //   currentDate && (currentDate < dayjs().add(1, 'days').startOf('day') || currentDate.day() === 0)
                      // }
                      disabled={!isEditable}
                    />
                  </Col>
                }
                <Col span={4} style={{ width: '100%' }}>
                  <label className="form-label">Created By</label>
                  <Input
                    name="CreatedBy"
                    value={formik.values["CreatedBy"]}
                    defaultValue={formik.values["CreatedBy"]}
                    disabled
                  />
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={14} style={{ width: '100%' }}>
                  <label className="form-label">Contract Notes</label>
                  <Input
                    name="ContractNotes"
                    value={formik.values.ContractNotes}
                    onBlur={() => formik.setFieldTouched("ContractNotes")}
                    onChange={formik.handleChange}
                    disabled={formik.values.DistributorID !== null ? !isEditable : true}
                  />
                </Col>
                <Col span={6} style={{ width: '100%' }}>
                  <label className="form-label">Revision</label>
                  <InputNumber
                    id="Revision"
                    // name="Revision"
                    value={formik.values.Revision !== null ? formik.values.Revision : 0}
                    defaultValue={formik.values.Revision !== null ? formik.values.Revision : 0}
                    // min={0}
                    // max={100}
                    style={{ width: '100%' }}
                    onBlur={() => formik.setFieldTouched("Revision")}
                    onChange={(value) => {
                      if (value < 0 || value > 100) {
                        message.error("Commission Percentage should be between 0 and 100");
                        return;
                      }
                      // allow only numbers
                      if (isNaN(value)) {
                        message.error("Commission Percentage should be a number");
                        return;
                      }
                      // allow only 2 decimal places
                      if (value.toString().split(".").length > 2) {
                        message.error("Commission Percentage should be a number");
                        return;
                      }
                      if (value.toString().split(".")[1]?.length > 2) {
                        message.error("Commission Percentage should be a number");
                        return;
                      }
                      formik.setFieldValue("Revision", value);
                    }}
                    disabled={formik.values.DistributorID !== null ? !isEditable : true}
                  />
                </Col>
              </Row>
              <Row gutter={16} style={{ marginTop: '20px' }}>
                <Col span={24} style={{ width: '100%' }}>
                  <label className="form-label">Upload Contract</label>
                  <Upload.Dragger
                    {...uploadProps}
                    customRequest={({ file, onSuccess }) => handleFile({ file, onSuccess }, "UploadContract")}
                    onPreview={() => downloadFile()}
                    fileList={uploadContractFileList}
                    onRemove={() => {
                      setUploadContract(null);
                      setUploadContractFileList([]);
                      setUploadContractFilename(null);
                    }}
                    disabled={formik.values.DistributorID !== null ? !isEditable : true}
                  >
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Drag or click to upload file</p>
                    <p className="ant-upload-hint">
                      Accepted format: PDF (Max file size limit: 4MB)
                    </p>
                  </Upload.Dragger>
                </Col>
              </Row>
              <div style={{ background: '#e3e3e3', borderRadius: '5px', padding: '0px 8px', margin: '80px 0px 20px 0px' }}>
                <p style={{ fontWeight: '600', fontSize: '18px', lineHeight: '36px' }}>Product Commission %</p>
              </div>
              <Table
                columns={columns}
                dataSource={productGroups}
                pagination={false}
                components={components}
                rowKey="key"
                bordered={false}
              />
              <div style={{ display: 'flex', justifyContent: 'end', marginTop: '20px' }}>
                <Button onClick={formik.handleSubmit} type='primary' style={{ background: '#27a907', fontSize: '14px', fontWeight: '600' }}>Save Contract</Button>
              </div>
            </form>
          )}
        </Formik>
      )}
    </div>
  );
}
export default NewCommissionContractTemp;
